export { default as TermLifeInsuranceWizardController } from "./TermLifeInsuranceWizardController";
